<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <div class="platform-cover"></div>
      <Nav />
      <div class="eol-main-container">
        <!-- 党性修养 -->
        <div class="culture-content">
          <div class="content-header">
            <div class="name"></div>
            <div class="other" v-if="cultureCat&&cultureCat.length>0">
              <div class="sub-content">
                <div class="sub-item" v-for="item,index in cultureCat" :key="index" @click="jumpList('culture',item)">{{ item.name }}</div>
              </div>
              <div class="more" @click="jumpList('culture')">更多</div>
            </div>
          </div>
          <div class="content-box" v-if="cultureData&&cultureData.length>0">
            <div class="content-block">
              <div class="big-cover" @click="jumpDetail(cultureData[0],'culture')" :style="`background:url(${cultureData[0].photo}) no-repeat center/cover;`"></div>
              <div class="sub-cover">
                <div class="cover-item" @click="jumpDetail(cultureData[1],'culture')" :style="`background:url(${cultureData[1].photo}) no-repeat center/cover;`"></div>
                <div class="cover-item" @click="jumpDetail(cultureData[2],'culture')" :style="`background:url(${cultureData[2].photo}) no-repeat center/cover;`"></div>
              </div>
            </div>
            <div class="content-block">
              <div class="sub-cover">
                <div class="cover-item" @click="jumpDetail(cultureData[3],'culture')" :style="`background:url(${cultureData[3].photo}) no-repeat center/cover;`"></div>
                <div class="cover-item" @click="jumpDetail(cultureData[4],'culture')" :style="`background:url(${cultureData[4].photo}) no-repeat center/cover;`"></div>
              </div>
              <div class="big-cover" @click="jumpDetail(cultureData[5],'culture')" :style="`background:url(${cultureData[5].photo}) no-repeat center/cover;`"></div>
            </div>
            <div class="content-block">
              <div class="sub-cover">
                <div class="cover-item" @click="jumpDetail(cultureData[6],'culture')" :style="`background:url(${cultureData[6].photo}) no-repeat center/cover;`"></div>
                <div class="cover-item" @click="jumpDetail(cultureData[7],'culture')" :style="`background:url(${cultureData[7].photo}) no-repeat center/cover;`"></div>
              </div>
              <div class="big-cover" @click="jumpDetail(cultureData[8],'culture')" :style="`background:url(${cultureData[8].photo}) no-repeat center/cover;`"></div>
            </div>
            <div class="content-block">
              <div class="big-cover" @click="jumpDetail(cultureData[9],'culture')" :style="`background:url(${cultureData[9].photo}) no-repeat center/cover;`"></div>
              <div class="sub-cover">
                <div class="cover-item" @click="jumpDetail(cultureData[10],'culture')" :style="`background:url(${cultureData[10].photo}) no-repeat center/cover;`"></div>
                <div class="cover-item" @click="jumpDetail(cultureData[11],'culture')" :style="`background:url(${cultureData[11].photo}) no-repeat center/cover;`"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 价值引领 -->
        <div class="value-content">
          <div class="content-header">
            <div class="name"></div>
            <div class="other" v-if="valueCat&&valueCat.length>0">
              <div class="sub-content">
                <div class="sub-item" @click="jumpList('value',item)" v-for="item,index in valueCat" :key="index">{{ item.name }}</div>
              </div>
              <div class="more" @click="jumpList('value')">更多</div>
            </div>
          </div>
          <div class="content-box" v-if="valueData&&valueData.length>0">
            <div class="content-item" @click="jumpDetail(item,'value')" v-for="item,index in valueData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
          </div>
        </div>
        <!-- banner -->
        <div class="banner-content"></div>
        <!-- 家国情怀 -->
        <div class="feelings-content">
          <div class="content-header">
            <div class="name"></div>
            <div class="other">
              <div class="sub-content" v-if="feelingsCat&&feelingsCat.length>0">
                <div class="sub-item" @click="jumpList('feelings',item)" v-for="item,index in feelingsCat" :key="index">{{ item.name }}</div>
              </div>
              <div class="more" @click="jumpList('feelings')">更多</div>
            </div>
          </div>
          <div class="content-box" v-if="feelingsData&&feelingsData.length>0">
            <div class="big-cover" :style="`background:url(${feelingsData[0].photo}) no-repeat center/cover;`" @click="jumpDetail(feelingsData[0],'feelings')"></div>
            <div class="sub-cover">
              <div class="cover-item" @click="jumpDetail(item,'feelings')" v-for="item,index in feelingsData.slice(1)" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
            </div>
          </div>
        </div>
        <!-- 职业素养 -->
        <div class="profession-content" v-if="professionData&&professionData.length>0">
          <div class="content-header">
            <div class="name"></div>
            <div class="other">
              <div class="sub-content">
                <div class="sub-item" @click="jumpList('profession',item)" v-for="item,index in professionCat" :key="index">{{ item.name }}</div>
              </div>
              <div class="more" @click="jumpList('profession')">更多</div>
            </div>
          </div>
          <div class="profession-box">
            <div class="show-cover" @click="jumpDetail(professionData[professionActive],'profession')" :style="`background:url(${professionData[professionActive].photo}) no-repeat center/cover;`"></div>
            <ul>
              <li v-for="item,index in professionData" :key="index" :class="[professionActive == index?'active':'']" @click="currentCover(item,index)">{{ item.name }}</li>
            </ul>
          </div>
        </div>
        <!-- fbanner -->
        <div class="fbanner-content"></div>
        <div class="double-content">
          <!-- 特色文化 -->
          <div class="content">
            <div class="content-header">
              <div class="name"></div>
              <div class="other">
                <div class="more" @click="jumpList('feature')">更多</div>
              </div>
            </div>
            <div class="content-box" v-if="featureData&&featureData.length>0">
              <div class="sub-cover">
                <div class="cover-item" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item,'feature')" v-for="item,index in featureData" :key="index"></div>
              </div>
            </div>
          </div>
          <!-- 生命教育 -->
          <div class="content">
            <div class="content-header">
              <div class="name"></div>
              <div class="other">
                <div class="more" @click="jumpList('vita')">更多</div>
              </div>
            </div>
            <div class="content-box" v-if="vitaData&&vitaData.length>0">
              <div class="big-cover" @click="jumpDetail(item,'vita')" v-for="item,index in vitaData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
            </div>
          </div>
        </div>
      </div>
      <Foohter />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Foohter from "@/components/Hzvtc/Footer.vue"
import ScreenAdapter from "@/components/ScreenAdapter.vue"
import services from '../../config/services'
import utils from "../../config/utils"
export default {
  data () {
    return {
      cover: require("../../assets/hzvtc/index/cover1.png"),
      cover2: require("../../assets/hzvtc/index/cover2.png"),
      professionActive: 0,
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      cultureData: [], // 党性修养数据
      valueData: [],// 价值引领数据
      feelingsData: [],// 家国情怀数据
      professionData: [], // 职业素养
      featureData: [], // 特色文化数据
      vitaData: [], // 生命教育数据
      // 二级分类数据
      cultureCat: [], // 党性修养二级分类
      valueCat: [], // 价值引领二级分类
      feelingsCat: [], // 家国情怀二级分类
      professionCat: [], // 职业素养二级分类
      // featureCat: [],// 特色文化二级分类
      // vitaCat: [], // 生命教育二级分类
    }
  },
  components: {
    Header,
    Nav,
    Foohter,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
    this.getCatData()
  },
  methods: {
    currentCover (item, index) {
      this.professionActive = index
    },
    // 跳转到课程详情
    jumpDetail (item, key) {
      // window.open(`/center/${this.school_code}/class/${item.id}`, "_blank")
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=${key}`, "_blank")
    },
    // 跳转到课程列表：点击更多跳转到列表，点击二级分类跳转列表锚点定位到指定分类下
    jumpList (key, info) {
      window.open(`/center/${this.school_code}/hzvtc/${key}${info ? ('?id=' + info.id) : ''}`, "_blank")
    },
    async getListData () {
      // 党性修养
      await services.getCourseList({ page: 1, size: 12, category_id: "106", school_code: this.school_code }).then(res => {
        this.cultureData = res.data.items
      })
      // 价值引领
      await services.getCourseList({ page: 1, size: 8, category_id: "110", school_code: this.school_code }).then(res => {
        this.valueData = res.data.items
      })

      // 家国情怀
      await services.getCourseList({ page: 1, size: 5, category_id: "121", school_code: this.school_code }).then(res => {
        this.feelingsData = res.data.items
      })

      // 职业素养
      await services.getCourseList({ page: 1, size: 100, category_id: "136", school_code: this.school_code }).then(res => {
        this.professionData = res.data.items
      })


      // 特色文化
      await services.getCourseList({ page: 1, size: 4, category_id: "195", school_code: this.school_code }).then(res => {
        this.featureData = res.data.items
      })

      // 生命教育
      await services.getCourseList({ page: 1, size: 1, category_id: "152", school_code: this.school_code }).then(res => {
        this.vitaData = res.data.items
      })

    },
    async getCatData () {
      // 党性修养二级分类
      await services.getCategoryList({ root_id: "106", school_code: this.school_code }).then(res => {
        this.cultureCat = res.data
      })

      // 价值引领二级分类
      await services.getCategoryList({ root_id: "110", school_code: this.school_code }).then(res => {
        this.valueCat = res.data
      })
      // 家国情怀二级分类
      await services.getCategoryList({ root_id: "121", school_code: this.school_code }).then(res => {
        this.feelingsCat = res.data
      })
      // 职业素养二级分类
      await services.getCategoryList({ root_id: "136", school_code: this.school_code }).then(res => {
        this.professionCat = res.data
      })
      // 特色文化二级分类
      // await services.getCategoryList({ root_id: "106", school_code: this.school_code }).then(res => {
      //   this.cultureCat = res.data
      // })
      // 生命教育二级分类
      // await services.getCategoryList({ root_id: "152", school_code: this.school_code }).then(res => {
      //   this.vitaCat = res.data
      // })

    },



  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  background: url('../../assets/hzvtc/cover/index.png') no-repeat center/cover;
  width: 100%;
  height: 520px;
}
.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  .content-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    position: relative;
    z-index: 1;
    .name {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 23px;
        margin-right: 18px;
        background: url('../../assets/hzvtc/index/title-block.png') no-repeat
          center/cover;
      }
      &::after {
        content: '';
        display: inline-block;
        width: 153px;
        height: 33px;
      }
    }
    .other {
      display: flex;
      align-items: center;
      .sub-content {
        display: flex;
        align-items: center;
        .sub-item {
          padding: 0 16px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          height: 32px;
          background: #d57048;
          border-radius: 4px;
          line-height: 32px;
          cursor: pointer;
          &:not(:last-child) {
            margin-right: 6px;
          }
        }
      }
      .more {
        margin-left: 26px;
        font-size: 15px;
        color: #b61e2a;
        cursor: pointer;
        display: flex;
        align-items: center;
        &::after {
          content: '';
          display: inline-block;
          width: 12px;
          height: 13px;
          background: url('../../assets/hzvtc/index/more.png') no-repeat
            center/cover;
          margin-left: 5px;
        }
      }
    }
  }
  .culture-content {
    margin-bottom: 58px;
    padding-top: 46px;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      height: 415px;
      background: url('../../assets/hzvtc/index/index-top-bg.png') no-repeat
        center/cover;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .content-header {
      margin-bottom: 38px;
      .name {
        &::after {
          background: url('../../assets/hzvtc/index/title-culture.png')
            no-repeat center/cover;
        }
      }
    }
    .content-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      z-index: 1;
      .content-block {
        width: 48.8%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:first-child,
        &:nth-child(2) {
          margin-bottom: 21px;
        }
        .big-cover {
          width: 390px;
          height: 219px;
          flex-shrink: 0;
          cursor: pointer;
        }
        .sub-cover {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          flex-shrink: 0;
          flex-direction: column;
          cursor: pointer;
          height: 219px;
          .cover-item {
            width: 176px;
            height: 99px;
          }
        }
      }
    }
  }
  .value-content {
    margin-bottom: 16px;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      height: 562px;
      background: url('../../assets/hzvtc/index/index-center-bg.png') no-repeat
        center/cover;
      position: absolute;
      top: 37px;
      left: 50%;
      transform: translateX(-50%);
    }
    .content-header {
      margin-bottom: 48px;
      .name {
        &::after {
          background: url('../../assets/hzvtc/index/title-value.png') no-repeat
            center/cover;
        }
      }
    }
    .content-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      z-index: 1;
      .content-item {
        width: 280px;
        height: 157px;
        margin-bottom: 24px;
        cursor: pointer;
      }
    }
  }
  .banner-content {
    background: url('../../assets/hzvtc/index/banner.png') no-repeat
      center/cover;
    width: 100%;
    height: 102px;
    margin-bottom: 40px;
    position: relative;
    z-index: 10;
  }
  .feelings-content {
    margin-bottom: 85px;
    .content-header {
      margin-bottom: 36px;
      .name {
        &::after {
          background: url('../../assets/hzvtc/index/title-fellings.png')
            no-repeat center/cover;
        }
      }
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      .big-cover {
        width: 587px;
        height: 330px;
        margin-right: 26px;
        flex-shrink: 0;
        cursor: pointer;
      }
      .sub-cover {
        display: flex;
        justify-content: space-between;
        flex: 1;
        flex-wrap: wrap;
        align-content: space-between;
        .cover-item {
          width: 280px;
          height: 157px;
          cursor: pointer;
        }
      }
    }
  }
  .profession-content {
    position: relative;
    margin-bottom: 64px;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      height: 563px;
      top: -37px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background: url('../../assets/hzvtc/index/index-footer-bg.png') no-repeat
        center/cover;
    }
    .content-header {
      margin-bottom: 38px;
      .name {
        &::after {
          background: url('../../assets/hzvtc/index/title-profession.png')
            no-repeat center/cover;
        }
      }
    }
    .profession-box {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 407px;
      background: #ad1e29;
      padding: 26px 0 27px 19px;
      display: flex;
      justify-content: space-between;
      .show-cover {
        width: 629px;
        height: 354px;
        cursor: pointer;
      }
      ul {
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar-thumb {
          background: #cecece;
        }
        li {
          width: 100%;
          height: 58px;
          line-height: 58px;
          font-size: 16px;
          font-weight: bold;
          color: #fbf2d3;
          cursor: pointer;
          transition: all 0.3s;
          border-bottom: 1px solid rgba(239, 191, 113, 0.14);
          &:hover,
          &.active {
            background: #efbf71;
            color: #ad1e29;
          }
          &::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('../../assets/hzvtc/index/title-arrow.png')
              no-repeat center/cover;
            margin: 0 18px 0 24px;
          }
        }
      }
    }
  }

  .fbanner-content {
    width: 100%;
    height: 102px;
    background: url('../../assets/hzvtc/index/f-banner.png') no-repeat
      center/cover;
    position: relative;
    z-index: 1;
  }
  .double-content {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1001;
    .content-header {
      padding: 34px 0;
    }
    .content {
      flex: 1;
      &:last-child {
        width: 587px;
        height: 330px;
        margin-left: 25px;
        flex-shrink: 0;
        .content-box {
          width: 100%;
          height: 100%;
        }
      }
      &:first-child {
        .content-header {
          padding-right: 20px;
          .name {
            &::after {
              background: url('../../assets/hzvtc/index/title-feature.png')
                no-repeat center/cover;
            }
          }
        }
      }
      .content-header {
        padding-right: 20px;
        .name {
          &::after {
            background: url('../../assets/hzvtc/index/title-vita.png') no-repeat
              center/cover;
          }
        }
      }

      .big-cover {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
      .sub-cover {
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        flex-wrap: wrap;
        height: 330px;
        .cover-item {
          width: 280px;
          height: 158px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .footer-container {
  margin-top: -36px;
}
</style>